/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import DoughnutGraphic from 'components/atoms/doughnut_graphic';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ManagementState, ManagementTypes } from 'store/modules/management_store/types';

interface ManagementMenuItemProps {
  featureId: string;
  featureLabel: string;
  isActive: boolean;
}

const ManagementMenuItem = (props: ManagementMenuItemProps) => {
  const { featureId, featureLabel, isActive } = props;
  const dispatch = useDispatch();

  const { request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  return (
    <div
      id={featureId}
      className={`card py-3 management-card-link ${isActive && 'active'}`}
      onClick={() => {
        dispatch({ type: ManagementTypes.UPDATE_SELECTED_FEATURE, selected_feature: featureId });
      }}
    >
      <div className="card-title text-center m-0">
        <h6>{featureLabel}</h6>
      </div>
      <div className="card-body text-center d-flex align-items-center justify-content-center p-0">
        {featureId === 'calendar' && (
          <i className="calendar-card material-icons py-4">calendar_month</i>
        )}
        {featureId !== 'calendar' && request.management_summary.loading && (
          <div className="text-center mt-5">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {featureId !== 'calendar' && request.management_summary.loaded && (
          <DoughnutGraphic featureId={featureId} featureLabel={featureLabel} isActive={isActive} />
        )}
      </div>
    </div>
  );
};

export default ManagementMenuItem;
